import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppRoutes } from '@helpers/app-routes';
import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class EnsureUserIsAuthenticated implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await this.authService.waitForInitialization();
    const isLoggedIn = this.authService.isLogged();

    if (!isLoggedIn) {
      // L'utilisateur n'est pas connecté, on redirige vers la page de login
      void this.router.navigate([AppRoutes.login]);
      return false;
    }

    // L'utilisateur est connecté
    return true;
  }
}
